// extracted by mini-css-extract-plugin
export default {"portalFormRowContainer":"PortalFormRow_portalFormRowContainer__cbeq0"};